/* eslint-disable jsx-a11y/control-has-associated-label */

import React from 'react'
import { FiExternalLink } from 'react-icons/fi'
import Header from '../../../components/header'
import * as S from './styles'

export interface Job {
  id: number
  estado: string
  especialidade: string
  linkVagas: string
}

interface VacanciesProps {
  vacancies: Job[]
  loading: boolean
  error: string | null
}

const Vacancies: React.FC<VacanciesProps> = ({ vacancies, loading, error }) => {
  const renderContent = () => {
    if (loading) {
      return (
        <S.LoadingContainer>
          <p>Carregando...</p>
        </S.LoadingContainer>
      )
    }

    if (error) {
      return <S.ErrorMessage>{error}</S.ErrorMessage>
    }

    if (vacancies.length === 0) {
      return (
        <S.EmptyState>
          <h3>Nenhuma vaga encontrada</h3>
          <p>Não há vagas disponíveis no momento.</p>
        </S.EmptyState>
      )
    }

    return (
      <S.TableContainer>
        <S.Table>
          <S.TableHead>
            <tr>
              <th>Estado</th>
              <th>Vaga</th>
              <th />
            </tr>
          </S.TableHead>
          <S.TableBody>
            {vacancies.map((job) => (
              <tr key={job.id}>
                <td>{job.estado}</td>
                <td>{job.especialidade}</td>
                <td>
                  <S.AccessLink
                    href={
                      job.linkVagas.startsWith('http')
                        ? job.linkVagas
                        : `https://${job.linkVagas}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Acessar vaga de ${job.especialidade} em ${job.estado}`}
                  >
                    Acessar
                    <FiExternalLink size={16} />
                  </S.AccessLink>
                </td>
              </tr>
            ))}
          </S.TableBody>
        </S.Table>
      </S.TableContainer>
    )
  }

  return (
    <S.Container>
      <Header title="Lista de Vagas Disponíveis" />
      <S.Content>{renderContent()}</S.Content>
    </S.Container>
  )
}

export default Vacancies
